/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { DeptDO, ResponseApi } from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class XiTongBuMenGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags XiTongBuMenGuanLi
   * @name QueryUsingGet
   * @summary 查询部门
   * @request GET:/dsp-admin/api/sys/dept
   * @secure
   */
  queryUsingGet = (
    query?: {
      name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ResponseApi, void>({
      path: `/dsp-admin/api/sys/dept`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongBuMenGuanLi
   * @name CreateUsingPost
   * @summary 新增部门
   * @request POST:/dsp-admin/api/sys/dept
   * @secure
   */
  createUsingPost = (resources: DeptDO, params: RequestParams = {}) =>
    this.request<ResponseApi, void>({
      path: `/dsp-admin/api/sys/dept`,
      method: "POST",
      body: resources,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongBuMenGuanLi
   * @name UpdateUsingPut
   * @summary 修改部门
   * @request PUT:/dsp-admin/api/sys/dept
   * @secure
   */
  updateUsingPut = (resources: DeptDO, params: RequestParams = {}) =>
    this.request<ResponseApi, void>({
      path: `/dsp-admin/api/sys/dept`,
      method: "PUT",
      body: resources,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongBuMenGuanLi
   * @name DeleteUsingDelete
   * @summary 删除部门
   * @request DELETE:/dsp-admin/api/sys/dept
   * @secure
   */
  deleteUsingDelete = (ids: number[], params: RequestParams = {}) =>
    this.request<ResponseApi, void>({
      path: `/dsp-admin/api/sys/dept`,
      method: "DELETE",
      body: ids,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongBuMenGuanLi
   * @name GetSuperiorUsingPost
   * @summary 查询部门:根据ID获取同级与上级数据
   * @request POST:/dsp-admin/api/sys/dept/superior
   * @secure
   */
  getSuperiorUsingPost = (ids: number[], params: RequestParams = {}) =>
    this.request<ResponseApi, void>({
      path: `/dsp-admin/api/sys/dept/superior`,
      method: "POST",
      body: ids,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new XiTongBuMenGuanLi();
